// TODO @Andrei let's re-spec and reimplement this. Low priority
import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style.js";
import {styleRule, keyframesRule} from "../../../../../../stem-core/src/decorators/Style.js";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {Messages} from "../../../../../Messages.js";
import {BlinkInput} from "../../../../../ui/Input.jsx";
import {SpinnerIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {CallThrottler, NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";


export class SpinnerAnimation extends StyleSheet {
    @keyframesRule
    rotatingKeyframes = {
        from: {
            transform: "rotate(0deg)",
        },
        to: {
            transform: "rotate(360deg)",
        },
    };
}

class DiscountCodeInputStyle extends StyleSheet {
    spinnerSize = 24;

    @styleRule
    container = {
        display: "flex",
        width: "100%",
        maxWidth: 418,
        textAlign: "center",
        margin: "auto",
    };

    @styleRule
    inputContainer = {
        display: "inline-block",
        flexDirection: "column",
        position: "relative",
        justifyContent: "center",
        flex: 1,
    };

    @styleRule
    inputFeedback = {
        position: "absolute",
        top: "100%",
        marginTop: 4,
        fontSize: this.themeProps.FONT_SIZE_SMALL,
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };

    @styleRule
    inputLabel = {
        fontSize: this.themeProps.FONT_SIZE_LARGE,
        marginRight: 8,
        display: "inline-block",
        whiteSpace: "nowrap",
        color: this.themeProps.TEXT_SECONDARY_COLOR,
        alignSelf: "center",
    };

    @styleRule
    input = {
        border: "1px solid transparent",
        width: `calc(100% - ${this.spinnerSize}px)`,
    };

    @styleRule
    loadingAnimation = {
        animation: `${SpinnerAnimation.getInstance().rotatingKeyframes} .6s linear infinite`,
        marginLeft: 12,
        position: "absolute",
        right: 0,
        // TODO: find another way to vertically align loading animation element
        top: "32%",
    };
}

@registerStyle(DiscountCodeInputStyle)
export class DiscountCodeInput extends UI.Element {
    lastSentCode = null;
    callThrottler = new CallThrottler({debounce: 300});

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            initialValue: "",
            discountApplied: null,
            onCodeInput: NOOP_FUNCTION,
            label: Messages.discountCodeInputLabel,
        }
    }

    render() {
        const {styleSheet} = this;
        const {discountApplied, initialValue, label} = this.options;

        return [
            label && <MessageElement className={styleSheet.inputLabel} message={label} />,
            <div className={styleSheet.inputContainer}>
                <BlinkInput
                    ref="input"
                    className={styleSheet.input}
                    initialValue={initialValue}
                    success={!!discountApplied}
                    onChange={() => this.onInputChange()}
                />
                {this.loading && <SpinnerIcon className={styleSheet.loadingAnimation}/>}
                {!(discountApplied || this.loading) && this.lastSentCode &&
                    <div className={styleSheet.inputFeedback}>
                        {Messages.invalidDiscountCode}
                    </div>}
            </div>,
        ];
    }

    // TODO @Mihai figure out a pattern around this
    async resendCode() {
        const currentValue = this.input.getValue();
        if (this.lastSentCode === currentValue) {
            return;
        }

        this.lastSentCode = currentValue;
        this.loading = true;
        this.redraw();

        await this.options.onCodeInput(this.lastSentCode);

        if (this.lastSentCode === currentValue) {
            // In case there was a race-condition in the meantime
            this.loading = false;
            this.redraw();
        }
    }

    onInputChange() {
        this.callThrottler.call(() => this.resendCode());
    }
}
